import { record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { FieldNamesObject, SupportedSchema } from './types';
import { unwrap } from './unwrap';

export const Compound = <Schema extends SupportedSchema>({
    schema,
    render,
    namePrefix,
}: {
    schema: Schema;
    render: (fieldNames: FieldNamesObject<Schema>) => React.ReactElement;
    namePrefix?: string;
}) => {
    const unwrappedSchema = unwrap<SupportedSchema>(schema);

    const fieldNames = pipe(
        unwrappedSchema.keyof().Values,
        record.mapWithIndex<string, string, string>((name) => (namePrefix ? `${namePrefix}.${name}` : name))
    ) as FieldNamesObject<Schema>;

    return render(fieldNames);
};
